import { RefObject, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useLocation, useParams } from 'react-router';
import { scrollGridToRow } from '../../../utils/scrollGridToRow';
import { useSelectedRowsContext } from '../../../hooks/context/useSelectedRowsContext';
import { getSubsetAndItemParams } from '../../../utils/getSubsetAndItemParams';
import { useDatasetContext } from '../../../hooks/context/useDatasetContext';
import { getDataKey } from '../../../utils/getDataKey';
import useRoutes from '../../../hooks/useRoutes';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { GlobalLocationStateType } from '../../../types/types';

export const useDatasetBackButtonGuard = (
  datasetShown: boolean | undefined,
  gridRef: RefObject<any>
) => {
  const history = useHistory();
  const { pathname, state } = useLocation<GlobalLocationStateType>();
  const { datasetId } = useParams<{ datasetId: string }>();
  const { t } = useTranslate();
  const routes = useRoutes();
  const { setExpandedRow } = useSelectedRowsContext();
  const { data, dataset, isGridLoading } = useDatasetContext();

  const dataKey = getDataKey(dataset);
  const dataLoaded = data !== undefined;

  useEffect(() => {
    const { itemId: subsetItemId } = getSubsetAndItemParams(pathname);
    if (
      isGridLoading ||
      state?.fromForms ||
      !datasetShown ||
      !subsetItemId ||
      !data
    )
      return;

    // This uscase is handled in DatasetList
    if (state?.forceFindInDataset === true) return;

    if (history.action === 'POP') {
      const foundIndex = data.findIndex(
        (row) => String(row[dataKey]) === subsetItemId
      );

      // When click back/forward button on item that is not in actual data
      if (foundIndex === -1) {
        toast(t('toasts.rowNotFound'));
        history.replace(routes.datasetList(datasetId));
        return;
      }

      scrollGridToRow(gridRef, foundIndex);
      setTimeout(() => {
        setExpandedRow(data[foundIndex]);
      }, 200);
    }
  }, [pathname, datasetShown, dataLoaded]);
};
